import { Component, Input } from '@angular/core';

@Component({
    selector: 'cognitive-icon',
    template: `
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16.97 25.45"
            [attr.width]="dimensions.width"
            [attr.height]="dimensions.height"
        >
            <title>Cognitive</title>

            <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                    <path
                        d="M17,7.42a6.37,6.37,0,0,1-1.71,4.44q-.75.81-1.23,1.44a10.6,10.6,0,0,0-1,1.58,4.69,4.69,0,0,0-.56,1.78A1.49,1.49,0,0,1,13.26,18a1.51,1.51,0,0,1-.41,1.06,1.57,1.57,0,0,1-.33,2.4,1.57,1.57,0,0,1,.21.78,1.42,1.42,0,0,1-.52,1.18,2,2,0,0,1-1.28.41,2.68,2.68,0,0,1-1,1.16A2.63,2.63,0,0,1,7,25a2.68,2.68,0,0,1-1-1.16,2,2,0,0,1-1.28-.41,1.42,1.42,0,0,1-.52-1.18,1.57,1.57,0,0,1,.21-.78,1.57,1.57,0,0,1-.33-2.4A1.51,1.51,0,0,1,3.71,18a1.49,1.49,0,0,1,.78-1.36,4.69,4.69,0,0,0-.56-1.78,10.6,10.6,0,0,0-1-1.58q-.49-.63-1.23-1.44A6.37,6.37,0,0,1,0,7.42,6.53,6.53,0,0,1,.74,4.37,7.08,7.08,0,0,1,2.68,2,9.64,9.64,0,0,1,5.39.54a9.14,9.14,0,0,1,6.18,0A9.64,9.64,0,0,1,14.29,2a7.08,7.08,0,0,1,1.94,2.35A6.53,6.53,0,0,1,17,7.42Zm-2.12,0a4.5,4.5,0,0,0-.57-2.22,5,5,0,0,0-1.49-1.68,7.68,7.68,0,0,0-2-1,7,7,0,0,0-4.52,0,7.68,7.68,0,0,0-2,1A5.06,5.06,0,0,0,2.69,5.2a4.5,4.5,0,0,0-.57,2.22,4.44,4.44,0,0,0,1.13,3l.5.55.51.55a9.1,9.1,0,0,1,2.34,4.94h3.78a9.1,9.1,0,0,1,2.34-4.94l.51-.55.5-.55A4.44,4.44,0,0,0,14.85,7.42Zm-2.65,0a.53.53,0,0,1-1.06,0,1.29,1.29,0,0,0-.89-1.18,4.16,4.16,0,0,0-1.76-.41.53.53,0,0,1,0-1.06A5.33,5.33,0,0,1,10.13,5a3.52,3.52,0,0,1,1.44.89A2.05,2.05,0,0,1,12.2,7.42Z"
                    />
                </g>
            </g>
        </svg>
    `,
    standalone: false
})
export class CognitiveIconSVGComponent {
    @Input()
    dimensions: { width: number | string; height: number | string } = {
        width: '100%',
        height: '100%'
    };
}
